import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// African countries with ISO 3166-1 numeric codes
const AFRICAN_COUNTRIES = [
    { code: "012", name: "Algeria" },
    { code: "024", name: "Angola" },
    { code: "204", name: "Benin" },
    { code: "072", name: "Botswana" },
    { code: "854", name: "Burkina Faso" },
    { code: "108", name: "Burundi" },
    { code: "120", name: "Cameroon" },
    { code: "132", name: "Cape Verde" },
    { code: "140", name: "Central African Republic" },
    { code: "148", name: "Chad" },
    { code: "174", name: "Comoros" },
    { code: "178", name: "Congo" },
    { code: "180", name: "DR Congo" },
    { code: "384", name: "Côte d'Ivoire" },
    { code: "262", name: "Djibouti" },
    { code: "818", name: "Egypt" },
    { code: "226", name: "Equatorial Guinea" },
    { code: "232", name: "Eritrea" },
    { code: "748", name: "Eswatini" },
    { code: "231", name: "Ethiopia" },
    { code: "266", name: "Gabon" },
    { code: "270", name: "Gambia" },
    { code: "288", name: "Ghana" },
    { code: "324", name: "Guinea" },
    { code: "624", name: "Guinea-Bissau" },
    { code: "404", name: "Kenya" },
    { code: "426", name: "Lesotho" },
    { code: "430", name: "Liberia" },
    { code: "434", name: "Libya" },
    { code: "450", name: "Madagascar" },
    { code: "454", name: "Malawi" },
    { code: "466", name: "Mali" },
    { code: "478", name: "Mauritania" },
    { code: "480", name: "Mauritius" },
    { code: "504", name: "Morocco" },
    { code: "508", name: "Mozambique" },
    { code: "516", name: "Namibia" },
    { code: "562", name: "Niger" },
    { code: "566", name: "Nigeria" },
    { code: "646", name: "Rwanda" },
    { code: "678", name: "São Tomé and Príncipe" },
    { code: "686", name: "Senegal" },
    { code: "690", name: "Seychelles" },
    { code: "694", name: "Sierra Leone" },
    { code: "706", name: "Somalia" },
    { code: "710", name: "South Africa" },
    { code: "728", name: "South Sudan" },
    { code: "729", name: "Sudan" },
    { code: "834", name: "Tanzania" },
    { code: "768", name: "Togo" },
    { code: "788", name: "Tunisia" },
    { code: "800", name: "Uganda" },
    { code: "732", name: "Western Sahara" },
    { code: "894", name: "Zambia" },
    { code: "716", name: "Zimbabwe" }
].sort((a, b) => a.name.localeCompare(b.name));

const AFRICAN_CODES = AFRICAN_COUNTRIES.map(c => c.code);
const ITEMS = AFRICAN_COUNTRIES.map(c => ({ id: c.code, name: c.name }));

const AfricaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 565,
                center: [18, 0]
            }}
            width={700}
            height={800}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => AFRICAN_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="africa"
            analyticsLocationType="african_country"
            trackingLabel="Africa Map"
            storageKey="africa_map"
            title="🌍 Africa Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Countries"
            unitLabel="countries"
            captionUnit="African countries"
            share={{
                region: 'Africa',
                fileName: 'visited-africa-map.png',
                trackId: 'africa'
            }}
            renderMap={renderMap}
        />
    );
};

export default AfricaMapSection;
